import { Link } from 'react-router-dom';
import { Home, ArrowLeft } from 'lucide-react';
import { useDocumentTitle } from '@/shared/hooks';

const NotFoundPage = () => {
  useDocumentTitle('404 - Page Not Found | BrokerMax');
  return (
    <div className="min-h-screen bg-background-primary flex items-center justify-center p-4">
      <div className="max-w-md w-full text-center">
        {/* 404 Large Number */}
        <div className="mb-8">
          <h1 className="text-9xl font-bold text-accent-primary opacity-20 mb-4">
            404
          </h1>
          <h2 className="text-3xl font-bold text-text-primary -mt-8">
            Page Not Found
          </h2>
        </div>

        {/* Description */}
        <div className="mb-8">
          <p className="text-text-secondary text-lg mb-4">
            Oops! The page you&apos;re looking for doesn&apos;t exist.
          </p>
          <p className="text-text-tertiary">
            It might have been moved, deleted, or you entered the wrong URL.
          </p>
        </div>

        {/* Action Buttons */}
        <div className="space-y-4">
          <Link
            to="/"
            className="w-full flex items-center justify-center gap-2 px-6 py-3 bg-accent-primary hover:bg-accent-secondary text-text-inverse rounded-lg transition-colors"
          >
            <Home className="h-5 w-5" />
            Go to Homepage
          </Link>

          <button
            onClick={() => window.history.back()}
            className="w-full flex items-center justify-center gap-2 px-6 py-3 bg-background-secondary hover:bg-background-hover text-text-primary border border-border-primary rounded-lg transition-colors"
          >
            <ArrowLeft className="h-5 w-5" />
            Go Back
          </button>

          {/* Search suggestion */}
        </div>

        {/* Help text */}
        <div className="mt-8 pt-6 border-t border-border-primary">
          <p className="text-text-tertiary text-sm">&copy; BrokerMax.ca</p>
        </div>
      </div>
    </div>
  );
};

export default NotFoundPage;
